module.exports = __webpack_public_path__ + "img/8.78c00549.png";